import React from "react";
import moment from "moment";
import Countdown from "react-countdown";
import { useSelector } from "react-redux";
import numeral from "numeral";
//
//component
//redux
//selector
import { bailiffDocumentDetailSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
import { FLOWS, useFlow } from "hook/bailiff/document/flow/useFlow";
import { Typography } from "antd";
import { useResponsive } from "hook/useResponsive";
//actions
//utils
//hook
//str
const BailiffTitle = () => {
  // -------------------------- VAR -----------------------------
  const { mobile, desktop } = useResponsive();
  const { flow } = useFlow();
  const isFlow = flow === FLOWS.PAID;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffDocumentDetailSelector);
  const status = detail?.status;
  const name = detail?.name;
  const downloadedAt = detail?.downloadedAt;
  const deletingAt = detail?.deletingAt;
  const mDonwload = moment(downloadedAt?.toDate()).add(1, "days");
  const mDeleteAt = moment(deletingAt?.toDate()).add(10, "minutes");
  const mTime = status === "deleting" ? mDeleteAt : mDonwload;
  // const mTime = status === "deleting";

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderCountDown = () => {
    return (
      <Countdown
        date={mTime}
        renderer={({ hours, minutes, seconds }) => {
          return (
            <div className="ml-1">
              {numeral(hours).format("00")}:{numeral(minutes).format("00")}:
              {numeral(seconds).format("00")}
            </div>
          );
        }}
      />
    );
  };

  const renderDownloaded = () => {
    if (!downloadedAt) return name;
    const label = !desktop ? (
      <div className="item-center flex flex-row">
        Xoá trong ({renderCountDown()})
      </div>
    ) : (
      <div className="item-center flex flex-row">
        {name} (Tài liệu này sẽ được xoá trong {renderCountDown()})
      </div>
    );
    return (
      <Typography.Text
        ellipsis={{ rows: 1 }}
        className="item-center flex flex-row text-[18px]"
      >
        {label}
      </Typography.Text>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <>
      {/* {renderDownloaded()} */}
      {isFlow && renderDownloaded()}
      {!isFlow && <span>Quay về trang chủ</span>}
    </>
  );
};
export default BailiffTitle;
